import { SmartCheckbox } from 'app/components/shared/FormComponents/SmartCheckbox'
import { SmartRadioGroup } from 'app/components/shared/FormComponents/SmartRadioGroup'
import { FormGroup } from 'app/components/shared/FormGroup'
import { RadioFormGroup } from 'app/components/shared/RadioFormGroup'
import { Radio } from 'app/components/ui/RadioGroup/Radio'
import React from 'react'

export const PrivacyFormSection = (): JSX.Element => {
  return (
    <>
      <FormGroup>
        <SmartCheckbox name='privacy_required'>
          Dichiaro di aver preso visione dell&apos;{' '}
          <a
            href='https://www.estra.it/informativa-cookies'
            target='_blank'
            rel='noopener noreferrer'
          >
            informativa privacy{' '}
          </a>
          titolare al quale i dati sono forniti.
        </SmartCheckbox>
      </FormGroup>
      <FormGroup>
        <SmartRadioGroup
          label='Presto il consenso per finalità di marketing diretto, mediante e-mail, sms, canali digitali, contatto telefonico con o senza operatore e/o posta ordinaria.'
          name='privacy_optional_internal_marketing'
        >
          <RadioFormGroup>
            <Radio value={true}>Sì</Radio>
            <Radio value={false}>No</Radio>
          </RadioFormGroup>
        </SmartRadioGroup>
      </FormGroup>
      <FormGroup>
        <SmartRadioGroup
          label='Acconsento al trasferimento dei miei dati ad altre società del Gruppo e/o a soggetti terzi per autonome finalità di marketing diretto, mediante e-mail, sms, canali digitali, contatto telefonico e/o posta ordinaria.'
          name='privacy_optional_external_marketing'
        >
          <RadioFormGroup>
            <Radio value={true}>Sì</Radio>
            <Radio value={false}>No</Radio>
          </RadioFormGroup>
        </SmartRadioGroup>
      </FormGroup>
    </>
  )
}
